import {UserState} from '../../../../../../types';
import {FormElementSelectOption} from '../../../../../form-element-select/types';

export function getAdaptedStates(states: UserState[]) {
	return states.map<FormElementSelectOption>(({stateID, name}) => ({
		label: name,
		value: String(stateID),
	}));
}
